import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { Tab, Tabs, Typography } from '@mui/material';
import IntlMessages from '@projectK/helpers/IntlMessages';
import NotificationPreferances from './NotificationPreferances';
import MessagePreferances from './MessagePreferances';
import { Fonts } from '@projectK/constants';
import CompanyTheme from '@projectK/constants/CompanyTheme';

const Notification = () => {
  const companyTheme = CompanyTheme();
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <Typography
        component='h3'
        sx={{
          fontSize: 16,
          fontWeight: Fonts.BOLD,
          color: companyTheme ? companyTheme.primary.main : 'text.primary',
        }}
      >
        <IntlMessages id='common.notifications' />
      </Typography>
      <Tabs
        value={value}
        onChange={handleChange}
        sx={{
          '& .crMuiTab': {
            textTransform: 'capitalize',
            p: 0,
          },
        }}
      >
        <Tab
          className='crMuiTab'
          style={{ marginRight: '25px' }}
          label={<IntlMessages id='faq.notificationPreferance' />}
        />
        <Tab
          className='crMuiTab'
          label={<IntlMessages id='faq.messagePreferance' />}
        />
      </Tabs>
      <Box
        sx={{
          mt: 4,
        }}
      >
        {value === 0 && <NotificationPreferances companyTheme={companyTheme} />}
        {value === 1 && <MessagePreferances companyTheme={companyTheme} />}
      </Box>
    </>
  );
};

export default Notification;
